import React from "react";
import "../Assets/css/index.css";
import { Container, Row, Col} from "react-bootstrap";
import PolicyNavbar from "./PolicyNavbar";


function CancellationPolicy() {
    return (
        <>
            <PolicyNavbar />
            <Container fluid className="policy-container">
                <Row className="MainContainerPadding">
                    <Col md={12} className="privacy-policy-content">
                        <div className="main-policy">
                            <div className="head-title">
                                <div className="policy-heading">CANCELLATION POLICY</div>
                                <div className="policy-heading-cancelation">Effective Date: June 9, 2025</div>
                            </div>
                            <div className="policy-content-cancellation">
                                <p>
                                    InSocial Orbit provides a platform connecting online content creators with business brands through three subscription tiers: Free, Monthly with Annual Commitment, and Enterprise. This Cancellation Policy outlines the terms and conditions for cancelling subscriptions and any associated refund eligibility. By subscribing to any InSocial Orbit plan, you agree to the terms outlined below.
                                </p>
                            </div>
                        </div>

                        {/* about-policy */}
                        <div className="about-policy">
                            <div className="head-title">
                                <div className="about-heading">1. General Terms</div>
                            </div>
                            <div className="Information-content">
                                <p className="cookie-title-cancellation">
                                    &bull; Subscription Purpose:
                                    <span className="information-point">
                                        InSocial Orbit facilitates connections between content creators and business brands. Subscription fees are charged for access to the platform and its services, regardless of whether a brand selects or rejects a content creator’s profile.{" "}
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Non-Refundable Fees:
                                    <span className="information-point">
                                        Subscription fees are non-refundable if InSocial Orbit connects a content creator with at least one business brand in a given billing month, as this constitutes fulfilment of the platform’s service obligation.{" "}
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Cancellation Requests:
                                    <span className="information-point">
                                        Cancellation requests must be submitted through the account management portal or by contacting support@insocialorbit.com. Requests are processed within 10 business days.{" "}
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Account Termination:
                                    <span className="information-point">
                                        Upon cancellation, access to the platform and its services will cease at the end of the current billing cycle or commitment period, depending on the subscription tier.{" "}
                                    </span>
                                </p>
                            </div>
                        </div>

                        {/* 2 - Information We Collect */}
                        <div className="main-Information">
                            <div className="head-title">
                                <div className="Information-heading">
                                    2. Subscription Tiers and Cancellation Terms
                                </div>
                            </div>
                            <div className="Information-heading">
                                2.1 Free Tier
                            </div>
                            <div className="Information-content">
                                <p className="cookie-title-cancellation">
                                    &bull; Overview :
                                    <span className="information-point">
                                        The Free Tier provides limited access to the platform with no subscription fee. Features offered under Free Tier may be changed from time to time at sole discretion of InSocial Orbit.
                                    </span>
                                </p>

                                <p className="cookie-title-cancellation">
                                    &bull; Cancellation :
                                    <span className="information-point">
                                        Users may deactivate their Free Tier account at any time through the account management portal. No fees or penalties apply.
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Data Retention:
                                    <span className="information-point">
                                        Upon deactivation, user data may be retained for up to 30 days before permanent deletion, unless otherwise requested.
                                    </span>
                                </p>
                            </div>
                            <div className="Information-heading">
                                2.2 Monthly with Annual Commitment Tier
                            </div>
                            <div className="Information-content">
                                <p className="info-title">
                                    &bull; Overview :
                                    <span className="information-point">
                                        This tier requires a 12-month commitment, billed monthly. Content creators gain access to enhanced platform features and priority brand connections.
                                    </span>
                                </p>
                                <p className="info-title">
                                    &bull; Cancellation :
                                </p>
                                <p className="info-title">
                                    &bull; Early Termination:
                                    <span className="information-point">
                                        Cancelling before the 12-month commitment period ends incurs an early termination fee equal to 50% of the remaining balance for the commitment period.
                                    </span>
                                </p>
                                <p className="info-title">
                                    &bull; Process:
                                    <span className="information-point">
                                        Submit cancellation requests at least 30 days before the desired cancellation date. Access continues until the end of the current billing month.
                                    </span>
                                </p>
                                <p className="info-title">
                                    &bull; Refunds:
                                    <span className="information-point">
                                        No refunds are issued for any month in which InSocial Orbit connects the content creator with at least one business brand. If no connections are made in a billing month, a refund may be requested within 7 days of the billing date, subject to review.
                                    </span>
                                </p>

                                <p className="info-title">
                                    &bull; Auto-Renewal:
                                    <span className="information-point">
                                        Subscriptions automatically renew for another 12
                                    </span>
                                </p>
                            </div>

                            <div className="Information-heading">
                                2.3 Enterprise Tier
                            </div>
                            <div className="Information-content">
                                <p className="cookie-title-cancellation">
                                    &bull; Overview :
                                    <span className="information-point">
                                        The Enterprise Tier is a customized plan for high-volume content creators or agencies, with pricing and terms outlined in a separate agreement.
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Cancellation :
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Contract Terms:
                                    <span className="information-point">
                                        Cancellation terms, including any early termination fees, are specified in the Enterprise agreement. Typically, a 60-day notice period is required.
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Refunds:
                                    <span className="information-point">
                                        Refunds are not provided for any month in which a brand connection is made, consistent with other tiers. Specific refund conditions may be outlined in the Enterprise agreement.
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Process:
                                    <span className="information-point">
                                        Contact your dedicated account manager or support@insocialorbit.com to initiate cancellation.
                                    </span>
                                </p>

                                <p className="cookie-title-cancellation">
                                    &bull; Custom Commitments:
                                    <span className="information-point">
                                        Enterprise plans may include multi-year commitments, with termination fees calculated based on the remaining contract value.
                                    </span>
                                </p>
                            </div>
                        </div>

                        {/* 3 - Purpose of Data Collection*/}
                        <div className="main-Data-Collection">
                            <div className="head-title">
                                <div className="Data-Collection-heading">
                                    3. Refund Eligibility
                                </div>
                            </div>
                            <div className="Data-Collection-content">
                                <p className="cookie-title-cancellation">
                                    &bull; Non-Refundable Cases :
                                </p>

                                <p>
                                    &bull; Subscription fees are non-refundable for any billing month in which InSocial Orbit facilitates at least one brand connection, regardless of whether the brand selects or rejects the content creator.
                                </p>

                                <p>
                                    &bull; Fees for completed billing cycles are non-refundable.
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Eligible Cases :
                                </p>

                                <p>&bull; Refunds may be considered for a billing month in which no brand connections were facilitated, provided the request is submitted within 7 days of the billing date.</p>
                                <p>
                                    &bull; Refunds, if approved, are processed within 10 business days and returned to the original payment method.
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Prorated Refunds:
                                    <span className="information-point">
                                        Enterprise plans may include multi-year commitments, with termination fees calculated based on the remaining contract value.
                                    </span>
                                </p>
                            </div>
                        </div>

                        {/* 4 - Data Sharing */}
                        <div className="main-policy">
                            <div className="head-title">
                                <div className="Data-Sharing-heading">4. Exceptions and Special Circumstances</div>
                            </div>
                            <div className="Information-content">
                                <p className="cookie-title-cancellation">
                                    &bull; Platform Failure:
                                    <span className="information-point">
                                        If InSocial Orbit fails to provide access to the platform due to technical issues for more than 48 consecutive hours in a billing month, users may request a prorated refund for the affected period, regardless of brand connections.
                                    </span>
                                </p>
                                <p className="cookie-title-cancellation">
                                    &bull; Legal Requirements:
                                    <span className="information-point">
                                        InSocial Orbit complies with applicable consumer protection laws. If local laws mandate specific refund or cancellation rights, those will supersede this policy.
                                    </span>
                                </p>

                                <p className="cookie-title-cancellation">
                                    &bull; Disputes:
                                    <span className="information-point">
                                        Any disputes regarding cancellations or refunds must be submitted in writing to support@insocialorbit.com. InSocial Orbit will respond within 10 business days.
                                    </span>
                                </p>
                            </div>
                        </div>

                        {/* 5 - Cookies */}
                        <div className="main-policy">
                            <div className="head-title">
                                <div className="Cookies-heading">5. Modifications to This Policy</div>
                                <div className="Cookies-content">
                                   &bull; InSocial Orbit reserves the right to modify this Cancellation Policy at any time. Changes will be communicated via email or through the platform at least 30 days before taking effect. Continued use of the platform after changes constitutes acceptance of the updated policy.
                                </div>
                            </div>
                            {/* 6 */}
                            <div className="head-title">
                                <div className="Data-Retention-titles">
                                    <span className="Data-Retentionchild-titles">
                                        {" "}
                                        6. Contact Information{" "}
                                    </span>
                                </div>
                                <div className="Data-Retentionchild-content">
                                    <p>
                                        &bull;  For cancellation requests, refund inquiries, or questions about this policy, please contact:
                                    </p>
                                </div>
                            </div>

                            <div className="main-policy">
                                <div className="head-title">
                                    <div className="Data-Sharing-heading">InSocial Orbit Support</div>
                                </div>
                                <div className="Cookies-content">
                                    Email: support@insocialorbit.com
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default CancellationPolicy;